export default "__VITE_ASSET__PboE6K$T__"